import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
    selector: 'app-edit-project-dialog',
    templateUrl: './edit-project-dialog.component.html',
})
export class EditProjectDialogComponent {
    form: FormGroup;
    keywords: string;

    editorConfig: AngularEditorConfig = {
        editable: true,
        spellcheck: true,
        height: '150px',
        minHeight: '50px',
        placeholder: 'Enter project description here...',
        translate: 'no',
        defaultParagraphSeparator: 'p',
        defaultFontName: 'Arial',
        toolbarHiddenButtons: [
            ['bold']
        ],
        customClasses: [
            {
                name: "quote",
                class: "quote",
            },
            {
                name: 'redText',
                class: 'redText'
            },
            {
                name: "titleText",
                class: "titleText",
                tag: "h1",
            },
        ]
    };

    constructor(
        private fb: FormBuilder,
        public dialogRef: MatDialogRef<EditProjectDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        const description = data.description || '';
        this.keywords = data.keywords ? (Array.isArray(data.keywords) ? data.keywords.join(', ') : data.keywords) : '';

        this.form = this.fb.group({
            keywords: [this.keywords],
            description: [description, Validators.required]
        });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    save(): void {
        if (this.form.valid) {
            const keywordsArray = this.form.value.keywords ? this.form.value.keywords.split(',').map(kw => kw.trim()).filter(kw => kw) : [];
            this.dialogRef.close({ ...this.form.value, keywords: keywordsArray });
        }
    }
} 